import { Outlet } from "react-router-dom";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/global/Footer";

function PortfolioLayout() {
  return (
    <div>
      <Navbar />
     
      <Outlet />
      <Footer />
    </div>
  );
}

export default PortfolioLayout;
